import { MarketCard, EventGroup } from "../../types";
import { CreationContext } from "../../types";
import {
  MOBILE_LEADERBOARD,
  LMLB
} from "@fresh8/ad-data-composition/src/useTemplateSize";
import { PROMO_GROUP } from "../../../../constants/market-types";

export function createPromoCard(
  event: EventGroup,
  context: CreationContext
): Array<MarketCard> {
  const marketIds = event.markets[PROMO_GROUP];

  if (!marketIds) return [];

  const promoCount = context?.brand?.adTemplate?.promoCount || 1;

  const promoCards = [] as MarketCard[];

  if (
    context.size.name === MOBILE_LEADERBOARD.name ||
    context.size.name === LMLB.name
  ) {
    marketIds.sort(() => (Math.random() > 0.5 ? 1 : -1));
  }

  let optionCount = 0;
  let marketCount = 0;

  for (let i = 0; i < promoCount; i++) {
    let currentMarketId = marketIds[marketCount];

    if (marketIds.findIndex(id => id === currentMarketId) === -1) {
      // go back to first market and increment option counter
      optionCount += 1;
      marketCount = 0;

      currentMarketId = marketIds[marketCount++];
    } else {
      marketCount += 1;
    }

    const options = context.betData.markets[currentMarketId].options;
    if (
      (context.size.name === MOBILE_LEADERBOARD.name ||
        context.size.name === LMLB.name) &&
      marketIds.length === 1
    ) {
      options.sort(() => (Math.random() > 0.5 ? 1 : -1));
    }

    const option = options[optionCount];

    if (!option) continue;

    promoCards.push(
      new MarketCard({
        type: "promo",
        eventId: event.id,
        marketIds: [currentMarketId],
        optionIds: [option]
      })
    );
  }

  return promoCards;
}
